import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { request } from 'http';
import { IEvaluationResponse, ICreateEvaluationRequest, IUpdateEvaluationRequest, IAddLignesRequest, ICreateEvaluationWithCompetencesRequest } from 'src/app/shared/models/evaluation';
import { IApplication } from 'src/app/shared/models/fiche-expression-besoin';


@Injectable({ providedIn: 'root' })
export class EvaluationService {

  private readonly apiUrl = '/api/v1/evaluations';

  constructor(private http: HttpClient) {}

  getAll(): Observable<IEvaluationResponse[]> {
    return this.http.get<IEvaluationResponse[]>(this.apiUrl);
  }

  getById(id: string): Observable<IEvaluationResponse> {
    return this.http.get<IEvaluationResponse>(`${this.apiUrl}/${id}`);
  }

  create(request: ICreateEvaluationRequest): Observable<IEvaluationResponse> {
    return this.http.post<IEvaluationResponse>(this.apiUrl, request);
  }

  update(id: string, request: IUpdateEvaluationRequest): Observable<IEvaluationResponse> {
    return this.http.patch<IEvaluationResponse>(`${this.apiUrl}/${id}`, request);
  }

updatedfmc(id: string, datefmc: string): Observable<IEvaluationResponse> {
  return this.http.patch<IEvaluationResponse>(
    `${this.apiUrl}/${id}/datefmc`,
    JSON.stringify(datefmc),                          // → body: "2026-07-20" (JSON valide)
    { headers: { 'Content-Type': 'application/json' } }
  );
}

  addMois(id: string): Observable<IEvaluationResponse> {
    return this.http.post<IEvaluationResponse>(`${this.apiUrl}/${id}/months`, {});
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  deleteMois(id: string, moisIndex: number): Observable<IEvaluationResponse> {
    return this.http.delete<IEvaluationResponse>(`${this.apiUrl}/${id}/months/${moisIndex}`);
  }

  validate(id: string): Observable<IEvaluationResponse> {
    return this.http.post<IEvaluationResponse>(`${this.apiUrl}/${id}/validate`, {});
  }

  archive(id: string): Observable<IEvaluationResponse> {
    return this.http.post<IEvaluationResponse>(`${this.apiUrl}/${id}/archive`, {});
  }


  createWithCompetences(request: ICreateEvaluationWithCompetencesRequest): Observable<IEvaluationResponse> {
    return this.http.post<IEvaluationResponse>(this.apiUrl, request);
  }

  addLignes(id: string, request: IAddLignesRequest): Observable<IEvaluationResponse> {
    return this.http.post<IEvaluationResponse>(`${this.apiUrl}/${id}/lignes`, request);
  }

  getActiveByUo(uniteOrganisationnelleId: string): Observable<any[]> {
    return this.http.get<any[]>(`/api/v1/referentiel/competences/actives?uniteOrganisationnelleId=${uniteOrganisationnelleId}`);
  }

  getByApplications(applications: IApplication[]): Observable<IEvaluationResponse[]> {
    return this.http.post<IEvaluationResponse[]>(`${this.apiUrl}/by-applications`, { applications });
  }

   exportData(): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/export`, { responseType: 'blob' });
  }

}